import React, { useState, useEffect } from "react"
import cx from "classnames"
import _get from "lodash/get"
import { NumericFormat as NumberFormat } from "react-number-format"
import { useDispatch, useSelector } from "react-redux"
import _isEmpty from "lodash/isEmpty"

import { addProduct, removeItems } from "@/store/features/favoritesSlice"
import { selectAuthState } from "@/store/features/authSlice"
import {
  getUserPersona,
  getPDPUrl,
  showNewBadge,
  sanitizeTextForAnalytics,
  getCurrentSkuCouponDiscounts,
} from "@/utils/helper"
import { getPresetUrl, onImageError } from "@/utils"
import { SWATCH_NA } from "@/constants"
import useWindowResize from "@/hooks/useWindowResize"

import Highlight from "@/components/core/Highlight/Highlight"
import { getConfig } from "@/constants/config"

import SocialShare from "@/components/SocialShare/v1/SocialShare"

import shareIcon from "@/public/icons/share.svg"
import wishIcon from "@/public/icons/wish.svg"
import filledWishIcon from "@/public/icons/wishlist-gray-filled.svg"

const ProductTile = props => {
  const {
    data = {},
    texts = {},
    lite,
    loading = false,

    compareData = {},
    highlightText = "",

    currencySign = "",
    isGrouped = false,
    rowCols,
    presetConfigs = "{}",
    isPartsDiagramLinkVisible = false,
    isFavoriteVariant = false,
    isVariantSku = {},
  } = props

  const isFavoriteIsVariantSelected = isFavoriteVariant && isVariantSku.sku

  const [isChecked, setIsChecked] = useState(false)
  const [showShare, setShowShare] = useState(false)
  const [onHover, setOnHover] = useState(false)
  const sku = data["sku_s"] ?? data["masterSKU_s"]
  const dispatch = useDispatch()
  const persona = getUserPersona()
  const [width] = useWindowResize()
  const cartData = useSelector(state => state.cart.data)
  const { isAuth: isAuthenticated } = useSelector(selectAuthState)
  const [siteName, setSiteName] = useState()
  const [swatchUrlData, setSwatchUrlData] = useState()

  useEffect(() => {
    getConfig().then(config => {
      const brandName = _get(config, "general.siteName")
      const { swatchUrl } = _get(config, "general")
      setSiteName(brandName)
      setSwatchUrlData(swatchUrl)
    })
  }, [])
  let images = []
  let productVariantImages = data["productImages.labelWithUrl_s"]
    ? [data["productImages.labelWithUrl_s"]]
    : data["productImages.labelWithUrl_ss"]
  let setDefaultProductImage = ""
  let setHoverProductImage = ""
  let isHover = true
  let variantImages = []
  if (productVariantImages?.length > 0) {
    let productVariantImagesFav = []
    if (isFavoriteIsVariantSelected) {
      const foundImages = productVariantImages.find(
        item => item.split("|")[0] === isVariantSku.sku
      )
      if (foundImages) {
        const otherImages = productVariantImages.filter(
          img => foundImages.split("|")[0] != img.split("|")[0]
        )
        productVariantImagesFav = [foundImages, ...otherImages]
      }
      variantImages = productVariantImages.filter(
        img => isVariantSku.sku === img.split("|")[0]
      )
      productVariantImages = [...productVariantImagesFav]
    } else {
      variantImages = productVariantImages.filter(
        img => sku === img.split("|")[0]
      )
    }

    if (props.plpPage) {
      variantImages.find(img => {
        const imgDetails = img.split("|")
        if (imgDetails[2] === props.defaultImage)
          return (setDefaultProductImage = imgDetails[1])
        else setDefaultProductImage = variantImages[0].split("|")[1]
      })
      productVariantImages.find(img => {
        const imgDetails = img.split("|")
        if (imgDetails[2] === props.hoverImage)
          return (setHoverProductImage = imgDetails[1])
      })
    } else {
      productVariantImages.find(img => {
        const imgDetails = img.split("|")
        if (isFavoriteIsVariantSelected) {
          if (isVariantSku.sku === imgDetails[0])
            return (setDefaultProductImage = imgDetails[1])
        } else {
          if (sku === imgDetails[0])
            return (setDefaultProductImage = imgDetails[1])
        }
      })
    }

    images.push(setDefaultProductImage)
    if (props.plpPage) {
      if (setHoverProductImage === "") {
        isHover = false
      }
      isHover === false
        ? images.push(setDefaultProductImage)
        : images.push(setHoverProductImage)
    }
  } else {
    images = ["MissingImage"]
  }

  // get variant image if color filters are applied
  let selColor = ""
  let variantPrice = 0
  let variantDiscPrice = 0
  if (props.mapImageToColor && props.currFilters) {
    const colorFilter = props.currFilters.find(
      q =>
        q.facet === "Color.Finish" ||
        q.facet === "Color" ||
        q.facet === "Finish"
    )
    const selColors = colorFilter?.value
    if (selColors?.length > 0) {
      let selectedProductImage = ""
      let i = selColors?.length - 1 ?? 0
      while (!selectedProductImage && i >= 0) {
        const colorName = selColors[i]
        if (data[`Color.${persona}.Details_ss`]) {
          const exactSKUDetails =
            data[`Color.${persona}.Details_ss`]
              .find(item => item.split("|")[1] === colorName)
              ?.split("|") ?? []
          selColor = selColors[i]
          const productId =
            exactSKUDetails[5]?.split("?")[0].split("/").slice(-1) ?? []
          selectedProductImage = productId[0] ?? ""
          variantPrice = exactSKUDetails[2] ?? 0
          variantDiscPrice = exactSKUDetails[3] ?? 0
        }
        i--
      }

      if (!selectedProductImage) selectedProductImage = "MissingImage"
      if (images[0] === images[1]) {
        images = [selectedProductImage, selectedProductImage]
      } else {
        images[0] = selectedProductImage
      }
    }
  }

  let colors = []
  if (data["Color.SKU.Details_ss"]) {
    colors = data["Color.SKU.Details_ss"].map(color => {
      const d = color.split("|")
      return {
        name: d[0],
        swatch: d[1],
        sku: d[2],
        isStock: d[3],
        isDiscontinued: d[4],
        customerFacingSKU: d[5],
      }
    })
  } else if (data["Color.SKU.Details_s"]) {
    const d = data["Color.SKU.Details_s"].split("|")
    colors = [
      {
        name: d[0],
        swatch: d[1],
        sku: d[2],
        isStock: d[3],
        isDiscontinued: d[4],
        customerFacingSKU: d[5],
      },
    ]
  } else if (data["SKU.Details_ss"]) {
    colors = data["SKU.Details_ss"].map(color => {
      const d = color.split("|")
      return {
        name: "",
        swatch: SWATCH_NA,
        sku: d[0],
        isStock: d[1],
        isDiscontinued: d[2],
        customerFacingSKU: d[3],
      }
    })
  }

  let selSku = ""
  if (props.mapImageToColor && selColor) {
    selSku = colors.find(item => item.name === selColor)?.sku ?? ""
  } else {
    selSku = sku
  }
  if (isFavoriteIsVariantSelected) {
    const foundColor = colors.find(item => item.sku === isVariantSku.sku)
    if (foundColor) {
      const otherColors = colors.filter(color => color.sku !== foundColor.sku)
      colors = [foundColor, ...otherColors]
    }
    selSku = isFavoriteIsVariantSelected
  }

  useEffect(() => {
    window.wow?.sync()
  }, [])

  useEffect(() => {
    const compareSku = selSku !== "" ? selSku : sku
    if (
      compareData.comparedProducts.find(prod => prod.compareSku === compareSku)
    )
      setIsChecked(true)
    else setIsChecked(false)
  }, [compareData.comparedProducts, data])

  colors = colors.filter(
    item =>
      item.isDiscontinued === "false" ||
      Date.parse(item.isDiscontinued) > Date.now()
  )
  const tileTitle = _get(data, "Tile_Title", "")
  const { isBundleProduct = false, productLocaleName = "" } = data

  const itemName = isGrouped
    ? _get(data, "Collapse_Title_s", "")
    : props.type === "parts"
    ? _get(data, "productName_s", "")
    : _get(data, "RegionBrandName_s", "") ||
      _get(data, "ProductBrandName_s", "")

  const productName = isBundleProduct ? productLocaleName : itemName

  const description = isGrouped
    ? _get(data, "Collapse_Description_s", "")
    : _get(data, "ProductDescriptionProductShort_s", "")

  const category = data.Product_Category
    ? data.Product_Category
    : data.ProductLocalCategory_s ?? ""

  const shipmentDate = _get(data, "RegionReleaseforShipment_dt", "")
  const isNewProduct = showNewBadge(shipmentDate)
  const badgeVal = _get(data, `priceList.${persona}.saleOffer_s`, "")
  let discountedPrice = _get(data, `priceList.${persona}.finalPrice_d`, 0)
  let finalPrice = _get(data, `priceList.${persona}.price_d`, 0)

  const price = _get(data, `priceStartingAt.${persona}_d`, 0)
  const [tileUrl, setTileUrl] = useState("")

  useEffect(() => {
    getPDPUrl(category, data.slug_s).then(ret => setTileUrl(ret))
  }, [data])

  const exclusiveBadge = _get(data, "ProductIsExclusive_s", "")
  const isFavorite = props.favorites?.find(
    vl => vl.productId === data["ctId_s"]
  )
    ? true
    : false
  const isDiscountedPrice = _get(
    data,
    `priceList.${persona}.discountedPrice_d`,
    0
  )
  const detaultSelectedColor = colors.length ? colors[0]?.name : ""
  const defaultCustomerFacingSku = colors.length
    ? colors[0]?.customerFacingSKU
    : ""
  const defaultImage = images.length ? images[0] : ""
  const defaultProductIsInStock = colors.length
    ? colors[0].isStock === "true" || colors[0].isStock === true
    : false
  const discountPercent =
    badgeVal && isDiscountedPrice
      ? 100 - Math.round((isDiscountedPrice / price) * 100)
      : 0
  const discountPriceState =
    badgeVal && isDiscountedPrice
      ? "percentOff|" + discountPercent
      : "regular price"
  const productIsRetail =
    _get(data, "ProductIsRetail", "") === "true" ? true : false
  const isSuperSku = _get(data, "comboSKUAvailable_b", null) ? true : false
  const discountAmount = discountPercent
    ? Number((price - isDiscountedPrice).toFixed(2))
    : 0
  const productSaleable = productIsRetail || !colors.length ? false : true
  const productRoom = _get(data, "category1_s", "n/a")
  const productCollectionsName = _get(data, "ProductBrandNameDisplay_s", "n/a")

  if (isGrouped) {
    finalPrice = _get(data, `priceStartingAt.${persona}_d`, 0)
    discountedPrice = _get(data, `discountedPriceStartingAt.${persona}_d`, 0)
  } else if (props.mapImageToColor && selColor && variantPrice > 0) {
    finalPrice = variantPrice
    discountedPrice = variantDiscPrice
  } else if (props.exactSKU) {
    const exactSKUDetails = data[`Color.${persona}.Details_ss`]
      ? data[`Color.${persona}.Details_ss`]
          .find(item => item.split("|")[0] === sku)
          .split("|")
      : []
    finalPrice = exactSKUDetails[2] ?? 0
    discountedPrice = exactSKUDetails[3] ?? 0
  }

  if (loading)
    return (
      <div className="product-tile--loading">
        <div className="loading-image shimmer"></div>
        <div className="loading-title shimmer"></div>
        <div className="loading-description shimmer"></div>
        <ul className="loading-swatch">
          <li className="shimmer"></li>
          <li className="shimmer"></li>
          <li className="shimmer"></li>
          <li className="shimmer"></li>
          <li className="shimmer"></li>
        </ul>
      </div>
    )
  const handleFavorite = e => {
    window.preActiveElement = e.target
    e.stopPropagation()
    e.preventDefault()
    if (isFavorite === true) {
      props.favorites?.map(fav => {
        if (fav.productId === data["ctId_s"]) {
          isAuthenticated(() =>
            dispatch(
              removeItems(
                [fav.id],
                texts.removeItem,
                texts.removeItemError,
                handleCallBack
              )
            )
          )
        }
      })
    } else {
      isAuthenticated(() =>
        dispatch(
          addProduct(
            sku,
            texts.favSuccessMsg,
            texts.favErrorMsg,
            handleCallBack
          )
        )
      )
    }
  }

  const handleCallBack = (status, message) => {
    const { adobeDataLayer: { getState } = {} } = window
    const page = (getState && getState("page")) || {}
    let isForSample = false
    if (page && page?.category?.subCategory1) {
      const {
        category: { subCategory1 },
      } = page
      isForSample = subCategory1.includes("samples")
    }
    const eventInfo = getEventInfo("favorite", null, true, isForSample)
    const productInfo = getProductInfo(null, true)
    eventInfo.eventStatus = status
    eventInfo.eventMsg = sanitizeTextForAnalytics(message)

    window.adobeDataLayer.push({
      event: "cmp:click",
      page,
      eventInfo,
      productInfo,
    })
  }

  const handleShare = e => {
    e.stopPropagation()
    e.preventDefault()
    setShowShare(true)
  }

  const badgeTxt = isNewProduct
    ? exclusiveBadge
      ? texts.newExclusive
      : texts.new
    : exclusiveBadge
    ? texts.exclusive
    : ""
  const pageRedirectUrl =
    props.type === "parts"
      ? `${tileUrl}${selSku ? "?skuId=" + selSku : "?skuId=" + sku}`
      : `${tileUrl}${selSku ? "?skuId=" + selSku : ""}`

  const redirectPDP = e => {
    e.preventDefault()
    e.stopPropagation()
    location.href = decodeURIComponent(pageRedirectUrl)
  }

  const setHover = () => {
    document
      .getElementById(`kf-product-tile-wrapper-${data["ctId_s"]}`)
      .classList.add("--hover")
    setOnHover(true)
  }
  const removeHover = () => {
    document
      .getElementById(`kf-product-tile-wrapper-${data["ctId_s"]}`)
      .classList.remove("--hover")
    setOnHover(false)
  }

  const presetConf = JSON.parse(presetConfigs)

  const getEventInfo = (
    type,
    color,
    needsJSON = false,
    isForSample = false
  ) => {
    /**
     * type is default navigation, could be favorite or share
     * color is optional, could be selected color from plp or search page product
     * needsJSON returns either JSON or stringified value
     */
    let alternameType
    let compareInternalLinkName
    if (type === "favorite") {
      if (isFavorite) {
        alternameType = "favorite remove"
      } else {
        alternameType = "favorite add"
      }
    } else if (type === "compare") {
      if (isChecked) {
        alternameType = "compare remove"
        compareInternalLinkName = "remove compare"
      } else {
        alternameType = "compare add"
        compareInternalLinkName = "add to compare"
      }
    }
    let selectedTab
    let pageSection
    if (props.favPage && props.selectedtab) {
      pageSection = "favorites"
      selectedTab = props.selectedtab.toLowerCase()
    }
    const plpPrefix = isForSample ? "plp:sample" : "plp"
    const selectedTabForSearchResults = props.type || "products"
    const eventInfo = {
      eventAction: `${
        pageSection
          ? "my account:" + pageSection + ":"
          : (props.plpPage ? plpPrefix : "search results") +
            (isForSample ? ":" : " ")
      }product ${alternameType || type || "navigation"}`,
      eventName: `${
        pageSection
          ? "my account:" + pageSection + ":"
          : (props.plpPage ? plpPrefix : "search results") +
            (isForSample ? ":" : " ")
      }product ${alternameType || type || "navigation"}`,
      eventType:
        isForSample || type === "favorite" ? "wishlist save" : "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName:
        type === "compare"
          ? compareInternalLinkName
          : alternameType ||
            sanitizeTextForAnalytics(type || productName + " " + description),
      internalLinkPosition:
        selectedTab ?? (props.plpPage ? plpPrefix : "search results"),
      internalLinkType: pageSection
        ? "my accounts:navigation"
        : `${props.plpPage ? plpPrefix : "search results"}:${
            type || (props.plpPage ? "navigation" : "product tiles")
          }`,
      internalLinkZoneName: selectedTab
        ? `my account:${pageSection}:${selectedTab}:main content area`
        : props.plpPage
        ? `${plpPrefix}:promo tiles`
        : `search results:${selectedTabForSearchResults}:main content area`,
      internalLinkURL: !type
        ? (tileUrl?.indexOf("http") === -1 ? window.location.origin : "") +
          tileUrl +
          (color ? "?skuId=" + color.sku : selSku ? "?skuId=" + selSku : "")
        : "n/a",
      clickInternalLinks: "true",
    }
    if (needsJSON) {
      eventInfo.custom = getProductInfo()
      return eventInfo
    }
    return JSON.stringify(eventInfo)
  }

  const getProductInfo = (color, needsJSON = false) => {
    const { productCouponCode, productCoupondiscount } =
      getCurrentSkuCouponDiscounts({ cart: cartData, sku: sku })
    const productInfo = {
      productInfo: {
        productBrand: siteName?.toLowerCase(),
        description: sanitizeTextForAnalytics(description) || "n/a",
        globalPromotionPrice:
          discountPercent && discountAmount
            ? Number((price - discountAmount).toFixed(2))
            : price,
        priceState: discountPriceState,
        productBasePrice: price,
        productCategory: sanitizeTextForAnalytics(category) || "n/a",
        productColor:
          sanitizeTextForAnalytics(color ? color.name : detaultSelectedColor) ||
          "n/a",
        productID:
          (color ? color.customerFacingSKU : defaultCustomerFacingSku) || "n/a",
        productName: sanitizeTextForAnalytics(productName) || "n/a",
        productRoom: sanitizeTextForAnalytics(productRoom || category) || "n/a",
        productSalePrice: discountedPrice ? discountedPrice : price,
        productSaleable: productSaleable,
        productStatus: color
          ? color.isStock === "true" || color.isStock === true
            ? "in stock"
            : "out of stock"
          : defaultProductIsInStock
          ? "in stock"
          : "out of stock",
        productSuperSku: isSuperSku,
        productTileName: sanitizeTextForAnalytics(tileTitle) || "n/a",
        defaultImageName: defaultImage || "n/a",
        productCollectionsName:
          sanitizeTextForAnalytics(productCollectionsName || category) || "n/a",
        globalOffer: badgeVal ? badgeVal : "n/a",
        globalDiscount: discountPercent ? discountAmount : "n/a",
        productPartnerBuyNow: productIsRetail,
        pdpType: "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCouponCode: productCouponCode.join("|") || "n/a",
        productCoupondiscount: productCoupondiscount,
        frequency: "n/a",
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        quantity: "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
      },
    }
    if (needsJSON) {
      return productInfo.productInfo
    }
    return JSON.stringify(productInfo)
  }

  const handleOnClickPartsDiagramLink = event => {
    event.preventDefault()
    props.handleOnClickPartsDiagramLink(data)
  }
  const { Brand_ss: BrandSs = [] } = data ?? {}
  const partsDiagram = texts?.partsdiagram
  const brandName = BrandSs[0] ?? ""
  const brandNameTolower = brandName?.toLowerCase()
  const isSameBrand = brandNameTolower?.startsWith(siteName?.toLowerCase())

  const getHref = () => {
    if (isSameBrand) {
      return {
        href: `${tileUrl}${tileUrl?.includes("?type=part") ? "&" : "?"}skuId=${
          selSku !== "" ? selSku : sku
        }`,
      }
    } else {
      return {}
    }
  }

  return (
    <div
      id={`kf-product-tile-wrapper-${data["ctId_s"]}`}
      className="product-tile__wrapper wow animate__fadeInUp"
      onFocus={setHover}
      onBlur={removeHover}
      onMouseLeave={() => setShowShare(false)}
    >
      <SocialShare
        showModal={showShare}
        id={`kf-plp-tile-${data["ctId_s"]}`}
        url={window.location.origin + tileUrl}
        onClose={() => setShowShare(false)}
        analyticData={getEventInfo("share", null, true)}
      />
      {!isFavoriteVariant ? (
        <div className="product-tile__badge">
          {_isEmpty(badgeVal) && !_isEmpty(badgeTxt) ? (
            <p className="product-tile__new">{badgeTxt}</p>
          ) : null}
          {!_isEmpty(badgeVal) ? (
            <p className="product-tile__offer">{texts.sale}</p>
          ) : null}
        </div>
      ) : null}

      <div
        role="link"
        id={props.id}
        className="product-tile__wrapper__card"
        tabIndex="0"
        onClick={isSameBrand ? redirectPDP : null}
      >
        <div
          className={cx({ "product-tile": true, "product-tile--lite": lite })}
        >
          <a
            tabIndex="-1"
            className="gbh-data-layer"
            data-gbh-data-layer={getEventInfo()}
            data-gbh-data-layer-custom={getProductInfo()}
            {...getHref()}
          >
            <div className="product-tile__image wow animate__fadeInUp">
              <div>
                {swatchUrlData
                  ? images.map((id, i) => {
                      const imgUrl = getPresetUrl(
                        width,
                        rowCols,
                        swatchUrlData,
                        id,
                        presetConf
                      )
                      return (
                        <img
                          role="presentation"
                          key={i}
                          src={imgUrl}
                          className={
                            images.length > 1 && i === 0
                              ? "product-tile__image--hover"
                              : ""
                          }
                          alt={data.metaTitle_s}
                          onError={e => onImageError(e, imgUrl)}
                        />
                      )
                    })
                  : null}
              </div>
            </div>
            <div className="product-tile__details wow animate__fadeInUp">
              <div>
                {props.favPage && (
                  <div className="product-brand_name">
                    {brandName == "KohlerPlumbing" ? "KOHLER" : brandName}
                  </div>
                )}
                {productName && (
                  <h3 aria-label={productName} className="product-tile__title">
                    <Highlight text={productName} highlight={highlightText} />
                  </h3>
                )}
                <div
                  aria-label={`${texts.productDescription}${description}`}
                  className="product-tile__description"
                >
                  <Highlight text={description} highlight={highlightText} />
                </div>
              </div>
              <div>
                {isGrouped && (
                  <p className="product-tile__startingat">{texts.startingAt}</p>
                )}
                {finalPrice > 0 && (
                  <p
                    aria-label={`${texts.salePriceAria}${data["displayPriceStartingAt_s"]}`}
                    className={`product-tile__price ${
                      !isGrouped && "product-tile_paddingtop"
                    }`}
                  >
                    <NumberFormat
                      value={
                        discountedPrice > 0 ? discountedPrice : finalPrice ?? 0
                      }
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={currencySign}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  </p>
                )}
                {discountedPrice !== finalPrice && discountedPrice > 0 && (
                  <p
                    aria-label={`${texts.originalPriceAria} ${finalPrice ?? 0}`}
                    className="product-tile__discount-price"
                  >
                    <NumberFormat
                      value={finalPrice ?? 0}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={currencySign}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  </p>
                )}
              </div>
            </div>
          </a>
        </div>
      </div>
      {!props.favPage && (
        <div className="product-tile__share">
          <button
            id={`kf-add-to-fav-${props.index}`}
            className="product-tile__share-icon"
            tabIndex="0"
            aria-hidden={width > 1024 ? (onHover ? false : true) : false}
            onClick={handleFavorite}
          >
            <img
              role="presentation"
              src={isFavorite ? filledWishIcon.src : wishIcon.src}
              alt={texts.wishlist}
            />
          </button>
          <button
            className="product-tile__share-icon-plp gbh-data-layer"
            tabIndex="0"
            aria-hidden={width > 1024 ? (onHover ? false : true) : false}
            data-gbh-data-layer={getEventInfo("share")}
            data-gbh-data-layer-custom={getProductInfo()}
            onClick={handleShare}
          >
            <img role="presentation" src={shareIcon.src} alt={texts.share} />
          </button>
        </div>
      )}
      {isPartsDiagramLinkVisible && (
        <div className="product-tile__wrapper__card__parts">
          <a
            href="#"
            className="product-parts__viewer"
            onClick={handleOnClickPartsDiagramLink}
          >
            {partsDiagram}
          </a>
        </div>
      )}
    </div>
  )
}

export default ProductTile
